import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import './index.css';

import Login         from './pages/Login';
import Layout        from './components/Layout';
import Dashboard     from './pages/Dashboard';
import Reminders     from './pages/Reminders';
import ReminderForm  from './pages/ReminderForm';
import ReminderDetail from './pages/ReminderDetail';
import Logs          from './pages/Logs';
import AuditLogs     from './pages/AuditLogs';
import Settings      from './pages/Settings';
import Users         from './pages/Users';
import Analytics     from './pages/Analytics';

function PrivateRoute({ children, roles }) {
  const { isAuthenticated, user } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user?.role)) return <Navigate to="/" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/" replace /> : children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#0f172a',
              color: '#f1f5f9',
              border: '1px solid #1e293b',
              borderRadius: '10px',
              fontSize: '13.5px',
              fontFamily: 'var(--font)',
              boxShadow: '0 8px 24px rgba(0,0,0,.2)',
            },
            success: { iconTheme: { primary: '#10b981', secondary: '#0f172a' } },
            error:   { iconTheme: { primary: '#ef4444', secondary: '#0f172a' } },
          }}
        />
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index                    element={<Dashboard />} />
            <Route path="reminders"         element={<Reminders />} />
            <Route path="reminders/new"     element={<PrivateRoute roles={['admin','manager','supervisor']}><ReminderForm /></PrivateRoute>} />
            <Route path="reminders/:id"     element={<ReminderDetail />} />
            <Route path="reminders/:id/edit" element={<PrivateRoute roles={['admin','manager','supervisor']}><ReminderForm /></PrivateRoute>} />
            <Route path="logs"              element={<PrivateRoute roles={['admin','manager','supervisor']}><Logs /></PrivateRoute>} />
            <Route path="audit"             element={<PrivateRoute roles={['admin']}><AuditLogs /></PrivateRoute>} />
            <Route path="users"             element={<PrivateRoute roles={['admin']}><Users /></PrivateRoute>} />
            <Route path="analytics"         element={<PrivateRoute roles={['admin','manager']}><Analytics /></PrivateRoute>} />
            <Route path="settings"          element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
